import { render } from "./PROJECT_ADDITION.vue?vue&type=template&id=72b8467a&ts=true"
import script from "./PROJECT_ADDITION.vue?vue&type=script&lang=ts"
export * from "./PROJECT_ADDITION.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__